import { cn } from '@/lib/utils';
import { Children, Fragment, isValidElement } from 'react';
import type { ReactNode } from 'react';

type TwoRowToolbarProps = {
  instructions: ReactNode;
  controls: ReactNode | ReactNode[];
  className?: string;
  fixedWidthPx?: number; // width for the instruction inner container
  showInstructions?: boolean;
};

export function TwoRowToolbar({ instructions, controls, className, fixedWidthPx, showInstructions = true }: TwoRowToolbarProps) {
  return (
    <div
      className={cn(
        'fm-node-bottom-toolbar-surface rounded-2xl bg-sidebar/95 backdrop-blur-xl border border-sidebar-border shadow-none overflow-hidden',
        className
      )}
      style={{ width: fixedWidthPx ? `${fixedWidthPx}px` : undefined }}
    >
      {showInstructions ? (
        <div className="min-h-[40px] flex items-start">
          <div
            className="relative flex-1 min-w-0 flex items-center"
            style={{ width: '100%' }}
          >
            {instructions}
          </div>
        </div>
      ) : null}
      {/* Second row: Controls */}
      <div className="flex items-center gap-1 px-1.5 py-1 h-[44px]">
        {Array.isArray(controls)
          ? Children.map(controls, (child, idx) => (
              <Fragment key={(isValidElement(child) && (child.key as any)) ?? idx}>{child}</Fragment>
            ))
          : controls}
      </div>
    </div>
  );
}


